import type { InputTextDesignTokens, InputTextTokenSections } from '@openng/optimus-ui-themes/types/inputtext';

export const root: InputTextTokenSections.Root = {
	filledBackground: '{form.field.background}',
	filledHoverBackground: '{form.field.background}',
	filledFocusBackground: '{form.field.background}',
	placeholderColor: '{surface.200}',
	sm: {
		fontSize: '0.875rem',
	},
	lg: {
		paddingX: '12px',
		paddingY: '8px',
	},
};

export default {
	root,
} satisfies InputTextDesignTokens;
